import global from '@utils/global';

export const getDateRichText = (date) => `<span>${date || ''}</span>`;
